module.exports = __webpack_public_path__ + "static/img/红魔 10Pro+.07d2cc7c.png";